import fifthaveClient from './fifthaveClient'
import bxlUtils from 'bxl-utils'

export function searchByDsl(dsl: string, cancelTokenSource?: any) {
  // dogfood domain not work
  return fifthaveClient.post(
    `https://5thave-prod.bieyangapp.com/api/v1/basic-data/_internal/forward/catalog/catalog/api/search/dsl`, 
    JSON.parse(dsl),
    {
      cancelToken: cancelTokenSource?.token,
  })
}

export function getQueryTranslate(query: string, cancelTokenSource?: any) {
  // dogfood domain not work
  return fifthaveClient.get(
    `https://5thave-prod.bieyangapp.com/api/v1/basic-data/_internal/forward/catalog/catalog/api/_internal/test/translate`,
    {
      cancelToken: cancelTokenSource?.token,
      params: {
        q: query,
      }
  })
}

export function getQueryAnalyze(query: string, cancelTokenSource?: any) {
  // dogfood domain not work
  return fifthaveClient.get(
    `https://5thave-prod.bieyangapp.com/api/v1/basic-data/_internal/forward/catalog/catalog/api/_internal/test/analyze`,
    {
      cancelToken: cancelTokenSource?.token,
      params: {
        q: query,
      }
  })
}

export function getQueryJargonRules(query: string, f: number = 0, size: number = 20, cancelTokenSource?: any) {
  // dogfood domain not work
  return fifthaveClient.get(
    `https://5thave-prod.bieyangapp.com/api/v1/basic-data/_internal/forward/catalog/catalog/api/search/jargon`,
    {
      cancelToken: cancelTokenSource?.token,
      params: {
        q: query,
        from: f,
        size: size,
      }
  })
}

export function discoverV2(queryParams: any, cancelTokenSource?: any) {
  return fifthaveClient.get('https://5thave-prod.bieyangapp.com/api/v2/discover', {
      params: queryParams,
      cancelToken: cancelTokenSource?.token,
      paramsSerializer: params => {
          return bxlUtils.uri.stringify(params)
      }
  })
}